import { createVuetify, type ThemeDefinition } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import { mdi } from 'vuetify/iconsets/mdi';
import { fa } from 'vuetify/iconsets/fa';

import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { ar, en } from 'vuetify/locale';
import { VuetifyDateAdapter } from 'vuetify/lib/composables/date';

import store from '../store';

const langStore: any = store.state;
const { lang } = langStore.lang;

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#374b8bff',
    secondary: '#5E3A5A',
    accent: '#e91e63',
    error: '#f44336',
    warning: '#FF5722',
    info: '#2196f3',
    success: '#3ed6a2',
    lightgray: '#f7f7f7',
    white: '#fff',
    darkgray: '#555555',
    middlegray: '#797979',
    gray: '#e6e6e6',
    black: '#000',
    'surface-variant': '#374b8bff',
  },
};

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: '#67b5da',
    secondary: '#e27d39',
    accent: '#e91e63',
    error: '#f44336',
    warning: '#FF5722',
    info: '#2196f3',
    success: '#51da81',
    lightgray: '#555555',
    white: '#000',
    darkgray: '#f7f7f7',
    middlegray: '#e6e6e6',
    gray: '#e6e6e6',
    black: '#f7f7f7',
  },
};

export default createVuetify({
  components,
  directives,

  date: {
    adapter: VuetifyDateAdapter,
    locale: {
      en: 'en',
      ar: 'ar',
    },
  },

  locale: {
    locale: lang,
    fallback: 'en',
    messages: {
      ar,
      en,
    },

    rtl: {
      ar: true,
      en: false,
    },
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      // dark: darkTheme,
    },
  },

  icons: {

    defaultSet: 'mdi',
    sets: {
      mdi,
      fa,
    },
  },
});
